export const personalInfo = {
  name: "Hit Bhalodia",
  role: "Senior Software Engineer",
  company: "rtCamp",
  location: "Rajkot, Gujarat, India",
  tagline: "Powering the web through WordPress, open source, and enterprise engineering.",
  heroLine: "Building, scaling, and improving WordPress for the modern web.",
  profileImage: "/images/hit-profile.jpg",
  workingImage: "/images/hit-working.jpg",
  links: {
    github: "https://github.com/hbhalodia/",
    wordpress: "https://profiles.wordpress.org/hbhalodia/",
    linkedin: "https://www.linkedin.com/in/hit-kumar-bhalodia-a031b9190/",
    twitter: "@hit_bhalodia",
    email: "mailto:work@hitbhalodia.me",
    website: "https://www.hitbhalodia.me",
  },
};

export const aboutData = {
  bio: "I'm a Senior Software Engineer at rtCamp, focused on enterprise WordPress engineering, Gutenberg, WordPress Core, performance, and open-source contribution. I enjoy solving problems that affect millions of sites and helping improve the tools that power a large part of the web.",
  extendedBio: "I work at the intersection of enterprise WordPress engineering and open-source contribution. From Gutenberg and Core fixes to performance, tooling, and editor experience, I care about building software that is reliable, scalable, and useful to the wider WordPress ecosystem.",
  highlights: [
    "WordPress Core",
    "Gutenberg",
    "Enterprise WordPress",
    "Performance",
    "WP-CLI",
    "Open Source",
    "PHP",
    "JavaScript",
    "React",
  ],
};

export const skillsData = [
  { name: "WordPress Core", category: "WordPress" },
  { name: "Gutenberg / Block Editor", category: "WordPress" },
  { name: "Enterprise WordPress", category: "WordPress" },
  { name: "Plugin Development", category: "WordPress" },
  { name: "Theme & Block Development", category: "WordPress" },
  { name: "WordPress REST API", category: "WordPress" },
  { name: "WP-CLI", category: "WordPress" },
  { name: "PHP", category: "Languages" },
  { name: "JavaScript", category: "Languages" },
  { name: "React", category: "Languages" },
  { name: "TypeScript", category: "Languages" },
  { name: "Performance Optimization", category: "Engineering" },
  { name: "Accessibility", category: "Engineering" },
  { name: "Internationalization", category: "Engineering" },
  { name: "Debugging & Code Quality", category: "Engineering" },
  { name: "GitHub Workflows", category: "Engineering" },
  { name: "Open-Source Collaboration", category: "Engineering" },
];

export const contributionBadges = [
  {
    title: "WordPress Core Contributor",
    description: "Active contributor to WordPress Core development",
    icon: "Shield",
  },
  {
    title: "Core Performance Contributor",
    description: "Contributing to WordPress performance improvements",
    icon: "Zap",
  },
  {
    title: "Pattern Author",
    description: "Creating block patterns for the WordPress ecosystem",
    icon: "Layout",
  },
  {
    title: "Plugin Developer",
    description: "Building and maintaining WordPress plugins",
    icon: "Puzzle",
  },
  {
    title: "Translation Contributor",
    description: "Translating WordPress into Gujarati and Hindi",
    icon: "Globe",
  },
  {
    title: "WP-CLI Contributor",
    description: "Improving WordPress command-line tools",
    icon: "Terminal",
  },
];

export const projectsData = [
  {
    title: "WordPress Core Contributions",
    description: "",
    technologies: ["PHP", "WordPress", "MySQL", "REST API"],
    link: "https://core.trac.wordpress.org/",
    type: "Open Source",
  },
  {
    title: "Gutenberg Contributions",
    description: "",
    technologies: ["React", "JavaScript", "WordPress", "Block Editor"],
    link: "https://github.com/WordPress/gutenberg",
    type: "Open Source",
  },
  {
    title: "Enterprise WordPress at rtCamp",
    description: "",
    technologies: ["WordPress", "PHP", "React", "Performance"],
    link: "https://rtcamp.com",
    type: "Enterprise",
  },
  {
    title: "WP-CLI & Tooling",
    description: "",
    technologies: ["PHP", "WP-CLI", "Bash", "Automation"],
    link: "https://wp-cli.org/",
    type: "Open Source",
  },
  {
    title: "GoDAM Plugin",
    description: "",
    technologies: ["PHP", "WordPress", "Plugin Dev", "REST API"],
    link: "#",
    type: "Plugin",
  },
  {
    title: "Translations & Community",
    description: "",
    technologies: ["i18n", "Gujarati", "Hindi", "Community"],
    link: "https://translate.wordpress.org/",
    type: "Community",
  },
];

export const timelineData = [
  {
    year: "2021",
    month: "",
    title: "WordPress Engineer Trainee at rtCamp",
    description:
      "Joined rtCamp as a WordPress Engineer Trainee, beginning the journey into enterprise WordPress development and open-source contribution.",
  },
  {
    year: "2021",
    month: "September",
    title: "Joined WordPress.org",
    description:
      "Started contributing to the WordPress open-source ecosystem, establishing a foundation as an active community member.",
  },
  {
    year: "2022",
    month: "",
    title: "WordPress Engineer at rtCamp",
    description:
      "Progressed to WordPress Engineer, taking on enterprise WordPress projects and earning recognition as a WordPress Core and Gutenberg contributor.",
  },
  {
    year: "2023",
    month: "",
    title: "Core Performance & Plugin Contributor",
    description:
      "Recognized for contributions to WordPress performance, expanded into plugin development, WP-CLI, and translations in Gujarati and Hindi.",
  },
  {
    year: "2024",
    month: "",
    title: "Senior WordPress Engineer at rtCamp",
    description:
      "Promoted to Senior WordPress Engineer, leading enterprise engineering work and mentoring new joiners as an rtBuddy.",
  },
  {
    year: "2025",
    month: "",
    title: "8 Consecutive Core Releases & WordCamp Asia",
    description:
      "Contributed to 8 consecutive WordPress Core releases up to v6.9, attended WordCamp Asia 2025, and continued driving open-source contributions across the ecosystem.",
  },
];

export const impactData = [
  {
    label: "Ecosystem Powering",
    value: "40%+",
    suffix: "of the web",
    description: "Contributing to the ecosystem powering over 40% of the web",
  },
  {
    label: "Core Contributor",
    value: "WordPress",
    suffix: "Core",
    description: "Active WordPress Core Contributor",
  },
  {
    label: "Block Editor",
    value: "Gutenberg",
    suffix: "Contributor",
    description: "Contributing to the future of WordPress editing",
  },
  {
    label: "Open Source",
    value: "Multi-Project",
    suffix: "Contributor",
    description:
      "Across Core, Gutenberg, WP-CLI, translations, and plugins",
  },
];

export const navLinks = [
  { label: "About", href: "#about" },
  { label: "Skills", href: "#skills" },
  { label: "Open Source", href: "#opensource" },
  { label: "Projects", href: "#projects" },
  { label: "Timeline", href: "#timeline" },
  { label: "Contact", href: "#contact" },
];
